module.exports = __webpack_public_path__ + "img/5.c4aea414.jpg";